import React, { useEffect, useMemo, useRef, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  fetchFormsByProject,
  AddTaskForm,
  UpdateTaskForm,
  DeleteTaskForm,
  FetchTaskForm,
  fetchFormById,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { Tooltip } from "antd";
import DocumentUploaderWithProgress22 from "../../components/Common/Document_Uploader_With_Progress22";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import DeleteIcon from "../../assets/icons/DeleteIcon.svg";
import XiconCircle from "../../assets/icons/x-circle.svg";
import DocumentImg from "../../assets/icons/Document-3.svg";
import PlusImgDotted from "../../assets/icons/plus-dotted-blue-icon.svg";
import PlusImg from "../../assets/icons/plus-circle-white.svg";
import searchicon from "../../assets/icons/search.svg";
import "../../assets/styles/local/Attachments.css";
import useScreenSize from "../../utils/hooks/useScreenSizeHook";
import StockAssigneeModal from "../../pages/dynamic/StockAssigneeModal";

const AddForm = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { taskId } = useParams();
  const screenSize = useScreenSize();
  const path = location.pathname;
  const hidden_Input_File = useRef(null);

  const isMyTask = location.pathname.includes("my-task");

  const addTaskResponse = useSelector((state) => state.user.addTaskResponse);
  const updateTaskResponse = useSelector(
    (state) => state.user.updateTaskResponse,
  );
  const formsByProjectRes = useSelector((state) => state.user.formsByProject);
  const addTaskFormRes = useSelector((state) => state.user.addTaskFormRes);
  const updateTaskFormRes = useSelector(
    (state) => state.user.updateTaskFormRes,
  );
  const deleteTaskFormRes = useSelector(
    (state) => state.user.deleteTaskFormRes,
  );
  const fetchTaskFormRes = useSelector((state) => state.user.fetchTaskFormRes);

  console.log("asc form props", props);

  const [openAssigneeModal, setOpenAssigneeModal] = useState();
  const [formOpen, setFormOpen] = useState(false);
  const [formData, setFormData] = useState([]);
  const [searchFormName, setSearchFormName] = useState("");
  const [selectFormName, setSelectFormName] = useState("");
  const [selectFormID, setSelectFormID] = useState("");
  console.log("asc formData", formData);
  const [formDataTable, setFormDataTable] = useState([]);
  console.log("asc formDataTable", formDataTable);

  useEffect(() => {
    if (props?.project?.projectid) {
      dispatch(fetchFormsByProject(props?.project?.projectid));
    }
  }, [props?.project?.projectid]);

  useEffect(() => {
    if (formsByProjectRes?.status === true) {
      setFormData(formsByProjectRes?.data);
    }
  }, [formsByProjectRes]);

  useEffect(() => {
    dispatch(FetchTaskForm(props.taskId));
  }, [addTaskFormRes, updateTaskFormRes, deleteTaskFormRes]);

  useEffect(() => {
    if (!props?.taskId || props.modalFunction === "add") {
      setFormDataTable([]);
      return;
    }

    if (fetchTaskFormRes?.status === true) {
      const mappedData = fetchTaskFormRes.data.map((task) => ({
        ...task,
        taskformassignees: task.taskformassignees.map((assignee) => ({
          // assigneeid: assignee.assigneeid,
          assigneeid:
            assignee.type.toLowerCase() === "single"
              ? assignee.assigneeid
              : assignee.teamid,
          assigneeTeamID: assignee.teamid,
          assigneeFirstName: assignee.assigneeName || "",
          assigneeLastName: "", // agar alag field nahi hai
          assigneeImgUrl: assignee.imageurl || "",
          taskFormAssigneesid: assignee.taskFormAssigneesid,
          assigneeType: assignee.type || "single",
        })),
      }));
      setFormDataTable(mappedData);
    }
  }, [fetchTaskFormRes]);

  useEffect(() => {
    if (addTaskResponse?.status === true) {
      // let payload = {
      //   taskid: addTaskResponse?.data?.taskid,
      //   taskform: formDataTable?.map((x) => ({
      //     formid: x.id,
      //     isCheck: x.isCheck,
      //     taskformassignees: x.taskformassignees?.map((a) => ({
      //       assigneeid: a.assigneeid,
      //     })),
      //   })),
      // };
      let payload = formDataTable?.map((x, i) => ({
        formid: x.id,
        indexPosition: fetchTaskFormRes?.data?.length + i,
        isCheck: x.isCheck,
        taskformassignees: x.taskformassignees?.map((y) => ({
          assigneeid: y.assigneeid,
        })),
      }));
      dispatch(AddTaskForm(addTaskResponse?.data?.taskid, payload));
    }
    if (updateTaskResponse?.status === true) {
      let payload = formDataTable
        ?.filter((x) => x.formid) // only items with formid
        .map((x, i) => ({
          taskFormid: x.taskFormid,
          indexPosition: x.indexPosition,
          formid: x.formid,
          isCheck: x.isCheck,
          taskformassignees: x.taskformassignees?.map((y) => ({
            taskFormAssigneesid: y.taskFormAssigneesid,
            assigneeid: y.assigneeid,
          })),
        }));
      if (payload?.length) {
        dispatch(UpdateTaskForm(props.taskId, payload));
      }

      //////// run AddTaskForm API in update time /////////
      let payload2 = formDataTable
        ?.filter((x) => !x.formid) // keep only items where formid is missing
        .map((x, i) => ({
          formid: x.id,
          indexPosition: fetchTaskFormRes?.data?.length + i,
          isCheck: x.isCheck,
          taskformassignees: x.taskformassignees?.map((y) => ({
            assigneeid: y.assigneeid,
          })),
        }));

      if (payload2?.length) {
        dispatch(AddTaskForm(props.taskId, payload2));
      }
    }
  }, [addTaskResponse, updateTaskResponse]);

  const handleAddTaskForm = (updatedData) => {
    console.log("asc66 handle add form", updatedData);
    const payload = updatedData.map((x, i) => ({
      formid: x?.id,
      indexPosition: fetchTaskFormRes?.data?.length + i,
      isCheck: x?.isCheck,
      // taskformassignees: x?.taskformassignees.map((y) => ({
      //   assigneeid: y?.assigneeid,
      // })),
      taskformassignees: (x?.taskformassignees || [])
        .filter((y) => y?.assigneeid)
        .map((y) => ({
          assigneeid: y?.assigneeid,
        })),
    }));

    dispatch(AddTaskForm(props.taskId, payload));
  };

  const handleUpdateTaskForm = (updatedData) => {
    console.log("asc66 handle update form", updatedData);
    let payload = updatedData
      ?.filter((x) => x.formid) // only items with formid
      .map((x, i) => ({
        taskFormid: x.taskFormid,
        indexPosition: x.indexPosition,
        formid: x.formid,
        isCheck: x.isCheck,
        taskformassignees: x.taskformassignees?.map((y) => ({
          taskFormAssigneesid: y.taskFormAssigneesid,
          assigneeid: y.assigneeid,
        })),
      }));

    if (payload?.length) {
      dispatch(UpdateTaskForm(props.taskId, payload));
    }
  };

  const [authorisedCoWorkerData, setAuthorisedCoWorkerData] = useState([
    // ...LocalAssineData,
  ]);

  const addUsersData = (asc, string) => {
    if (string === "single") {
      console.log("asc66 single", asc, string);
      setAuthorisedCoWorkerData([...authorisedCoWorkerData, asc]);
    }
    if (string === "Teams") {
      console.log("asc66 Teams", asc, string);
      setAuthorisedCoWorkerData([...authorisedCoWorkerData, asc]);
    }
    // if (asc.length > 1) {
    //   // here ... will add and open asc array.
    //   setAuthorisedCoWorkerData([...authorisedCoWorkerData, ...asc]);
    // }
  };

  const removeUsersData = (asc, string) => {
    if (string === "single") {
      let workers = authorisedCoWorkerData.filter((x) => x.id !== asc.id);
      setAuthorisedCoWorkerData(workers);
    }
    if (string === "Teams") {
      let workers = authorisedCoWorkerData.filter(
        (x) => x.teamID !== asc.teamID,
      );
      setAuthorisedCoWorkerData(workers);
    }
    // if (asc.length > 1) {
    //   let workers = authorisedCoWorkerData.filter(
    //     (x) => !asc.some((user) => user.id === x.id)
    //   );
    //   setAuthorisedCoWorkerData(workers);
    // }
  };

  console.log("asc66 assinee", authorisedCoWorkerData);

  useEffect(() => {
    if (openAssigneeModal === false) {
      updateAssignees();
    }
    setOpenAssigneeModal(null);
  }, [openAssigneeModal === false]);

  const updateAssignees = () => {
    const updatedData = formDataTable.map((x) => {
      if (x?.id === selectFormID || x?.formid === selectFormID) {
        return {
          ...x,
          taskformassignees: authorisedCoWorkerData.map((user) => {
            // check if original data has this assignee
            const fromFetchAssignee = x.taskformassignees?.find(
              (a) => a.assigneeid === user.id,
            );

            return {
              // assigneeid: user.id,
              assigneeid:
                user.type.toLowerCase() === "single" ? user.id : user.teamID,
              assigneeTeamID: user.teamID || "",
              assigneeFirstName: user.firstName,
              assigneeLastName: user.lastName,
              assigneeImgUrl: user.imageurl,
              assigneeType: user.type,
              taskFormAssigneesid: fromFetchAssignee
                ? fromFetchAssignee.taskFormAssigneesid
                : "",
            };
          }),
        };
      }
      return x;
    });

    setFormDataTable(updatedData);
    handleUpdateTaskForm(updatedData);
    setOpenAssigneeModal(false);
  };

  // related to form builder Execute form start.
  const existingFormContent = useSelector((state) => state.user.formById);

  useEffect(() => {
    if (existingFormContent?.data?.[0]?.sections) {
      const updatedSections = existingFormContent?.data?.[0]?.sections?.map(
        (section) => {
          const updatedChildren = section?.children?.map((child) => {
            return { ...child, id: Math.ceil(Math.random() * 1000) };
          });
          return {
            ...section,
            iscomplete: section?.iscomplete === 1 ? true : false,
            children: updatedChildren,
            id: Math.ceil(Math.random() * 1000),
          };
        },
      );
      // setFormComponents(updatedSections);
      localStorage.setItem("formComponents", JSON.stringify(updatedSections));
    }
  }, [existingFormContent]);
  // related to form builder Execute form end.

  return (
    <div style={{ marginTop: "2rem", position: "relative", display: "non-e" }}>
      <div
        className={`task-modal-dependencies-box-1 frcb 
        ${screenSize === "xs" && "px-3"}`}
        style={{ color: "#333333" }}
      >
        <p className="mb-0">Forms</p>
        <p
          className="mb-0"
          onClick={() => {
            setFormOpen(!formOpen);
          }}
        >
          Add a form...
        </p>
      </div>

      {formOpen && (
        <div
          className="asc_Custom_Select_Outer22"
          style={{
            top: "10px",
            left: "85px",
            width: "65%",
          }}
        >
          <div className="d-flex align-items-baseline">
            <section className="asc_Search_Icon_Search mx-2 ms-3">
              <img
                src={searchicon}
                className="asc_searchicon"
                alt="Search Icon"
              />
              <input
                id="asc_input"
                className="asc_Search_Input w-75"
                placeholder="Search..."
                //   placeholder={FetchTranslationList[66]?.translation}
                value={searchFormName}
                onChange={(e) => setSearchFormName(e.target.value)}
              />
            </section>
            <img
              src={XiconCircle}
              className="xicon pointer d-flex ms-auto mt-2 me-2"
              style={{ width: "20px", height: "20px" }}
              alt=""
              onClick={() => {
                setFormOpen(false);
              }}
            />

            {/* <p className="asc_Search_Client_Text pt-2 ps-2">Select Unit</p> */}
          </div>

          <section className="asc_Search_List ps-0 pb-2" id="ascSelectBox">
            {formData
              ?.filter((x) =>
                x.formName
                  ?.toLowerCase()
                  .includes(searchFormName.toLowerCase()),
              )
              .map((item, index) => {
                return (
                  <div
                    key={index}
                    className="ulterDrop ps-4"
                    onClick={() => {
                      setSearchFormName("");
                      setSelectFormName(item.formName);
                      setSelectFormID(item.formId);
                      setFormOpen(false);
                      //   setFormDataTable(prev => [...prev, item.formName]);
                      // setFormDataTable((prev) => [
                      //   ...prev,
                      //   {
                      //     name: item.formName,
                      //     id: item.formId,
                      //     isCheck: 0,
                      //     taskformassignees: [
                      //       {
                      //         assigneeid: "",
                      //       },
                      //     ],
                      //   },
                      // ]);

                      const exists = formDataTable.find(
                        (x) => x.id === item.formId || x.formid === item.formId,
                      );
                      if (exists) return;

                      let updatedData = [
                        {
                          name: item.formName,
                          id: item.formId,
                          isCheck: 0,
                          // taskformassignees: [
                          //   {
                          //     assigneeid: "",
                          //   },
                          // ],
                        },
                      ];
                      setFormDataTable((prev) => [...prev, ...updatedData]);

                      handleAddTaskForm(updatedData);
                    }}
                  >
                    <img src={DocumentImg} alt="" className=" opacity-50" />
                    &nbsp; &nbsp;
                    {item.formName}
                  </div>
                );
              })}
            {formData.length === 0 && (
              <span className="noDataDisplay">
                No data to display!
                {/* {FetchTranslationList?.data?.data[94]?.translation} */}
              </span>
            )}
          </section>
        </div>
      )}

      {/* selected form as table below */}
      {formDataTable?.map((item, index) => {
        console.log("asc66 formTable", item);
        return (
          <div>
            <div
              // className="d-flex align-items-center ms-2 ps-4 py-2"
              className={`d-flex align-items-center ms-2 py-2
              ${screenSize === "xs" ? "ps-2" : "ps-4"}`}
            >
              <div className="d-flex align-items-center gap-3">
                <input
                  type="checkbox"
                  checked={item.isCheck}
                  className="form-check-input pointer companyRadio"
                  style={{
                    borderRadius: "50%",
                    backgroundImage: "var(--bs-form-check-bg-image)",
                  }}
                  onChange={(e) => {
                    let updatedData = formDataTable.map((x) => {
                      const isMatch =
                        (x.id && item.id && x.id === item.id) ||
                        (x.formid && item.formid && x.formid === item.formid);

                      return isMatch ? { ...x, isCheck: e.target.checked } : x;
                    });

                    setFormDataTable(updatedData);

                    handleUpdateTaskForm(updatedData);
                  }}
                />

                {item?.taskformassignees?.length > 0 ? (
                  <>
                    {item?.taskformassignees
                      ?.slice(0, 3)
                      ?.map((x, innderIndex) => {
                        return (
                          <div key={innderIndex}>
                            {x.assigneeImgUrl ? (
                              <img
                                src={x.assigneeImgUrl}
                                className="pointer"
                                style={{
                                  width: "35px",
                                  height: "35px",
                                  borderRadius: "50%",
                                  position: "relative",
                                  // marginLeft: "-20px",
                                  marginLeft:
                                    innderIndex === 0 ? "0px" : "-30px",
                                  border: "0.2vw #ffffff solid ",
                                  objectFit: "cover",
                                }}
                                alt=""
                                onClick={() => {
                                  setOpenAssigneeModal(true);
                                  setSelectFormID(item.id || item.formid);

                                  let updatedAssignees = (
                                    item?.taskformassignees || []
                                  ).map((user) => ({
                                    firstName: user.assigneeFirstName || "",
                                    lastName: user.assigneeLastName || "",
                                    imageurl: user.assigneeImgUrl || "",
                                    jobtypename: "",
                                    id: user.assigneeid || "",
                                    teamID: user.assigneeTeamID || "",
                                    type:
                                      user.assigneeType.toLowerCase() ===
                                      "single"
                                        ? "single"
                                        : "Teams",
                                    isLatest: "isLatest",
                                  }));
                                  setAuthorisedCoWorkerData(updatedAssignees);
                                }}
                              />
                            ) : (
                              <div
                                className="abbre-pop pointer"
                                style={{
                                  width: "35px",
                                  height: "35px",
                                  marginLeft:
                                    innderIndex === 0 ? "0px" : "-30px",
                                }}
                                onClick={() => {
                                  setOpenAssigneeModal(true);
                                  setSelectFormID(item.id || item.formid);

                                  let updatedAssignees = (
                                    item?.taskformassignees || []
                                  ).map((user) => ({
                                    firstName: user.assigneeFirstName || "",
                                    lastName: user.assigneeLastName || "",
                                    imageurl: user.assigneeImgUrl || "",
                                    jobtypename: "",
                                    id: user.assigneeid || "",
                                    teamID: user.assigneeTeamID || "",
                                    type:
                                      user.assigneeType.toLowerCase() ===
                                      "single"
                                        ? "single"
                                        : "Teams",
                                    isLatest: "isLatest",
                                  }));
                                  setAuthorisedCoWorkerData(updatedAssignees);
                                }}
                              >
                                {/* {x?.lastName
                                  ? x?.firstName[0]?.toUpperCase() +
                                    "" +
                                    x?.lastName[0]?.toUpperCase()
                                  : x?.firstName?.slice(0, 2).toUpperCase()} */}
                                {x?.assigneeLastName
                                  ? x?.assigneeFirstName[0]?.toUpperCase() +
                                    "" +
                                    x?.assigneeLastName[0]?.toUpperCase()
                                  : x?.assigneeFirstName
                                      ?.slice(0, 2)
                                      .toUpperCase()}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    {/* rest of counted assignee 👇 */}
                    {item?.taskformassignees?.length > 3 && (
                      <div
                        className="px-1 lengthInCircle z-1"
                        style={{ marginLeft: "-30px" }}
                      >
                        +{item?.taskformassignees.length - 3}
                        <p className="d-none">ASC</p>
                      </div>
                    )}
                  </>
                ) : (
                  <img
                    src={PlusImgDotted}
                    className="pointer"
                    style={{
                      width: "30px",
                      height: "30px",
                      position: "relative",
                    }}
                    alt=""
                    onClick={() => {
                      setOpenAssigneeModal(true);
                      setSelectFormID(item.id || item.formid);
                      setAuthorisedCoWorkerData([]);
                    }}
                  />
                )}

                {openAssigneeModal &&
                  (selectFormID === item.id ||
                    selectFormID === item.formid) && (
                    <div
                      style={{
                        position: "absolute",
                        top: "10px",
                        // left: "35px",
                        left: isMyTask ? "0" : "35px",
                        // width: "100vw",
                        width: isMyTask ? "100%" : "100vw",
                      }}
                    >
                      <StockAssigneeModal
                        sendingData={authorisedCoWorkerData} // only sending Data.
                        addUsersData={addUsersData}
                        removeUsersData={removeUsersData}
                        closeAssigneeModal={setOpenAssigneeModal}
                        // headerMaxAmount={headerMaxAmount}
                        // setHeaderMaxAmount={setHeaderMaxAmount}
                        showWorkersTab={true}
                        showTeamsTab={true}
                      />
                    </div>
                  )}

                <p
                  className="mb-0 pointer"
                  onClick={() => {
                    // history.push(`${item.link}`);
                    // history.push(`/form/${item.formid}/sign`);

                    dispatch(fetchFormById(item.formid));
                    setTimeout(() => {
                      // history.push(`/form/${item.formid}/sign`);
                      history.push({
                        pathname: `/form/${item.formid}/sign`,
                        state: {
                          from: "Add_Form_Screen",
                          taskId: taskId,
                        },
                      });
                      // window.open(`/form/${item.formid}/sign`, "_blank");
                    }, 1000);
                  }}
                >
                  {item.name || item.formName}
                </p>
              </div>

              <img
                src={DeleteIcon}
                className="opacity-50 pointer ms-auto me-4"
                style={{ width: "18px", height: "18px" }}
                alt=""
                onClick={() => {
                  if (item.taskFormid) {
                    dispatch(DeleteTaskForm(item.taskFormid));
                  } else {
                    let data = [...formDataTable];
                    data.splice(index, 1);
                    setFormDataTable(data);
                  }
                }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AddForm;
